function hasProperty(obj, fields) {
  return Object.keys(obj).filter((v) => fields.includes(v)).length > 0;
}
export {
  hasProperty
};
//# sourceMappingURL=HasProperty.js.map
